import AppSubMenu from "./AppSubMenu";
import {model} from "../config/menu-config";

const AppMenu = () => {

    return <AppSubMenu model={model} />;
};

export default AppMenu;
